import { ApiResult, HttpClient } from "../http.js";
import {
  CompanyGoalDto,
  GoalProgressDto,
  CreateGoalPayload,
  UpdateGoalPayload,
} from "../types/goals.js";

export class GoalsApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<CompanyGoalDto[]>> {
    return this.http.get<CompanyGoalDto[]>("/api/goals");
  }

  get(id: string): Promise<ApiResult<CompanyGoalDto>> {
    return this.http.get<CompanyGoalDto>(`/api/goals/${encodeURIComponent(id)}`);
  }

  getProgress(id: string): Promise<ApiResult<GoalProgressDto>> {
    return this.http.get<GoalProgressDto>(`/api/goals/${encodeURIComponent(id)}/progress`);
  }

  create(payload: CreateGoalPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/goals", { body: payload });
  }

  update(id: string, payload: UpdateGoalPayload): Promise<ApiResult<CompanyGoalDto>> {
    return this.http.put<CompanyGoalDto>(`/api/goals/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<boolean>> {
    return this.http.delete<boolean>(`/api/goals/${encodeURIComponent(id)}`);
  }
}
